import './PageBanner.scss';
import pageBanner from '../../assets/backgroundImages/microsite-events-page-banner.png';
import MaronlineTriLogo from '../../assets/Tri-Brand-Maroline-logos-Framed-big-white.png';

interface PageBannerProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

export const PageBanner: React.FC<PageBannerProps> = ({ 
  title,
  subtitle,
  className = ''
}) => {
  return (
    <div className={`page-banner ${className}`.trim()}>
      <div className="page-banner__overlay" />
      <img 
        src={pageBanner} 
        alt="" 
        className="page-banner__background" 
      />
      <div className="page-banner__content">
        <div className="page-banner__text">
          <img 
            src={MaronlineTriLogo} 
            alt="Maroline Tri Logo" 
            className="page-banner__logo"
          />
          <h1 className="page-banner__title">{title}</h1>
          <p className="page-banner__subtitle">{subtitle}</p>
        </div>
      </div>
    </div>
  );
};
